function menuOpen() {

    const allButtonsInMenuGroup = document.querySelectorAll('.wp-block-acf-nav-mega-menu-group__button');

    for (const button of allButtonsInMenuGroup) {

        button.addEventListener('mouseenter', (event) => {

            //clear all buttons aria-expanded state to false when toggling the menu.
            clearAllButtonsAriaExpandedState();

            const clickedButton = event.currentTarget;
            clickedButton.setAttribute('aria-expanded', 'true');
        
        });
    }
}

function menuLeave() {

    const allMenuContainers = document.querySelectorAll('.wp-block-acf-nav-mega-menu-group__menu-container');

    for (const container of allMenuContainers) {

        container.addEventListener('mouseleave', (event) => {

            //clear all buttons aria-expanded state to false when leaving the menu.
            clearAllButtonsAriaExpandedState();

        });
    }
}

function clearAllButtonsAriaExpandedState() {

    const allButtonsInMenuGroup = document.querySelectorAll('.wp-block-acf-nav-mega-menu-group__button');

    for (const button of allButtonsInMenuGroup) {

        button.setAttribute('aria-expanded', 'false')
    }
}



//init on document loaded
document.addEventListener("DOMContentLoaded", function () {

    menuOpen()
    menuLeave()
})